module.exports = __webpack_public_path__ + "static/media/51.b5f8b6f6.jpg";